import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, tap } from 'rxjs';
import { ApiService } from 'src/app/features/http-services/api.service';
import { StorageService } from 'src/app/features/http-services/storage.service';
import { API_CONSTANTS } from 'src/app/features/shared/constants/api';

@Injectable({
  providedIn: 'root'
})
export class OrdersService {
  isItemAddToPostOrder: boolean = false;

  constructor(
    private apiService: ApiService,
    private storageService: StorageService
  ) { }

  getDivisionList(data: any = {}, payload = {}) {
    const endpoint = API_CONSTANTS.divisionList
      .replace("{userId}", data.username)
      .replace("{builderUnitId}", data.builderUid);
    return this.apiService.post(endpoint, payload).pipe(map(({ body }: any) => body));
  }

  getSubDivisionList(data: any = {}, payload = {}) {
    const endpoint = API_CONSTANTS.subDivisionList
      .replace("{userId}", data.username);
    return this.apiService.post(endpoint, payload).pipe(map(({ body }: any) => body));
  }

  getProductStyleList(payload: any) {
    const endpoint = API_CONSTANTS.productStyleList
      .replace("{userId}", payload.username)
      .replace("{builderUid}", payload.builderUid)
      .replace("{styleNumber_Or_Name}", payload.styleName)
      .replace("{isPartNumberSearch}", payload.isPartNumberSearch);
    return this.apiService.get(endpoint).pipe(map(({ body }) => body));
  }

  getSKUList(payload: any, data: any = {}) {
    let endpoint = API_CONSTANTS.skuList
      .replace("{userId}", payload.username)
      .replace("{styleCode}", payload.styleCode);
       if (data.isPartNumberSearch) {
        endpoint += `&partNumber=${data.partNumber || ""}`;
      }
    return this.apiService.get(endpoint).pipe(map(({ body }) => body));
  }

  getUOMList(payload: any) {
    const endpoint = API_CONSTANTS.uomList
      .replace("{userId}", payload.username)
      .replace("{productCode}", payload.productCode);
    return this.apiService.get(endpoint).pipe(map(({ body }) => body));
  }

  createATP(data: any, payload: any) {
    const endpoint = API_CONSTANTS.atp
      .replace("{userId}", data.username)
      .replace("{cartId}", data.cartId)
      .replace("{builderUid}", data.builderUid);
    return this.apiService.post(endpoint, payload).pipe(map(({ body }: any) => body));
  }

  addToCart(data: any, payload: any) {
    // console.log("payload==============1=>", payload);
    const endpoint = API_CONSTANTS.addToCart
      .replace("{userId}", data.username)
      .replace("{cartId}", data.cartId)
      .replace("{builderNumber}", data.builderNumber)
      .replace("{productCode}", data.productCode);
    return this.apiService.post(endpoint, payload).pipe(map(({ body }: any) => body));
  }

  addDivision(payload: any) {
    const endpoint = API_CONSTANTS.addDivision
      .replace("{userId}", payload.username)
      .replace("{cartId}", payload.cartId)
      .replace("{divisionUid}", payload.divisionUid);
    return this.apiService.put(endpoint, payload);
  }

  addSubDivision(payload: any) {
    const endpoint = API_CONSTANTS.addSubDivision
      .replace("{userId}", payload.username)
      .replace("{cartId}", payload.cartId)
      .replace("{subDivisionUid}", payload.subDivisionUid)
      .replace("{subDivisionFreeText}", payload.subDivisionFreeText);
    return this.apiService.put(endpoint, payload);
  }

  addLotInfo(data: any, payload: any) {
    const endpoint = API_CONSTANTS.addLotInfo
      .replace("{userId}", data.username)
      .replace("{cartId}", data.cartId)
      .replace("{builderUid}", data.builderUid);
    return this.apiService.post(endpoint, payload);
  }

  getCart(payload: any) {
    const endpoint = API_CONSTANTS.getCart
      .replace("{userId}", payload.username)
      .replace("{cartId}", payload.cartId);
      // .replace("{orgId}", payload.orgId);
    
    // Restructure cart repsone
    return this.apiService.get(endpoint).pipe(map(({ body }) => {
      const entries = (body?.camsCartEntries || []).map((item: any) => {
        return (item.cartEntries || []).map((entry: any) => {
          const { cartEntries, ...camsDetails } = item || {};
          return {
            ...(entry || {}),
            __camsdetails: camsDetails,

          }
        });
      });
      body.entries = entries.flat();
      return body;
    }));
  }
  getdownloadPDF(data: any) {
    const endpoint = API_CONSTANTS.downloadPDF
      .replace("{userId}", data.username)
      .replace("{orderCode}", data.orderCode)
    return this.apiService.get(endpoint).pipe(map(({ body }) => body));
  }

  sharePDF(payload:any){
    const endpoint = API_CONSTANTS.shareOrderToEmail;
    return this.apiService.post(endpoint, payload, {
      Headers, responseType: 'text'
    }, true).pipe(map(({ body }: any) => body));
  }

  getSubmittedForList(payload: any) {
    const endpoint = API_CONSTANTS.getSubmittedForList
      .replace("{userId}", payload.username);
    return this.apiService.get(endpoint).pipe(map(({ body }) => body));
  }

  getReserverEligility(payload: any) {
    const endpoint = API_CONSTANTS.eligibilityReserverCart
      .replace("{cartId}", payload.cartId);
    return this.apiService.get(endpoint).pipe(map(({ body }: any) => body));
  }

  changeQuantity(data: any, payload: any) {
    const endpoint = API_CONSTANTS.changeQuantity
      .replace("{userId}", data.username)
      .replace("{cartId}", data.cartId)
      .replace("{builderNumber}", data.builderNumber);
    return this.apiService.post(endpoint, payload).pipe(map(({ body }: any) => body));
  }

  changeQuantityAddToCart(data: any, payload: any) {
    const endpoint = API_CONSTANTS.changeQuantityAddToOrder
      .replace("{userId}", data.username)
      .replace("{cartId}", data.cartId)
      .replace("{builderNumber}", data.builderNumber);
    return this.apiService.post(`${endpoint}?code=${payload?.productCode}`, payload).pipe(map(({ body }: any) => body));
  }

  cancelLine(payload: any) {
    const endpoint = API_CONSTANTS.deleteLine
      .replace("{userId}", payload.username)
      .replace("{cartId}", payload.cartId)
      .replace("{entryNumber}", payload.entryNumber);
    return this.apiService.post(endpoint, null).pipe(map(({ body }: any) => body));
  }

  cancelCart(payload: any) {
    const endpoint = API_CONSTANTS.deleteLine
      .replace("{userId}", payload.username)
      .replace("{cartId}", payload.cartId)
      .replace("{entryNumber}", payload.entryNumber);
    return this.apiService.post(endpoint, {}).pipe(map(({ body }: any) => body));
  }

  

  
  cancelSolution(data: any, payload: any) {
    const endpoint = API_CONSTANTS.cancelSolution
      .replace("{userId}", data.username)
      .replace("{cartId}", data.cartId)
      .replace("{accountUid}", data.accountUid);
    return this.apiService.post(endpoint, payload).pipe(map(({ body }: any) => body));
  }
  proceedToCheckout(data: any, payload: any) {
    const endpoint = API_CONSTANTS.proceedTocheckout
      .replace("{userId}", data.username)
      .replace("{cartId}", data.cartId);
    return this.apiService.post(endpoint, payload).pipe(map(({ body }: any) => body));
  }
  proceedToReserve(data: any, payload: any) {
    const endpoint = API_CONSTANTS.proceedTocheckout
      .replace("{userId}", data.username)
      .replace("{cartId}", data.cartId);
    return this.apiService.post(endpoint, payload).pipe(map(({ body }: any) => body));
  }


  updatePostOrderLotInfo(data: any, payload: any) {
    const endpoint = API_CONSTANTS.postOrderUpdateLotInfo
      .replace("{userId}", data.username)
      .replace("{builderUid}", data.builderUid)
      .replace("{orderCode}", data.orderCode);
    return this.apiService.put(endpoint, payload);
  }

  getOrderDetails(data: any) {
    const endpoint = API_CONSTANTS.orderDetails
      .replace("{userId}", data.username)
      .replace("{orderCode}", data.orderCode)
    return this.apiService.post(endpoint, null).pipe(map(({ body }: any) => body));
  }

  postOrderCancel(data: any) {
    const endpoint = API_CONSTANTS.postOrderCancel
      .replace("{userId}", data.username)
      .replace("{orderCode}", data.orderCode)
      .replace("{cancellationCode}", data.cancellationCode)
    return this.apiService.put(endpoint, {});
  }

  postOrderCancelLine(data: any) {
    const endpoint = API_CONSTANTS.postOrderCancelLine
      .replace("{userId}", data.username)
      .replace("{orderCode}", data.orderCode)
      .replace("{entryNumber}", data.entryNumber)
      .replace("{cancellationCode}", data.cancellationCode)
    return this.apiService.put(endpoint, {});
  }

  postOrderAddNewLineATP(data: any, payload: any = {}) {
    const endpoint = API_CONSTANTS.postOrderAddNewLineATP
      .replace("{userId}", data.username);
    return this.apiService.post(endpoint, payload).pipe(map(({ body }: any) => body));
  }

  postOrderAddNewLine(data: any, payload: any = {}) {
    const endpoint = API_CONSTANTS.postOrderAddNewLine
      .replace("{userId}", data.username)
      .replace("{orderNumber}", data.orderNumber)
      .replace("{productCode}", data.productCode)
      .replace("{quantity}", data.quantity)
    return this.apiService.post(endpoint, payload).pipe(map(({ body }: any) => body));
  }

  postOrderChangeQuantity(data: any, payload: any = {}) {
    const endpoint = API_CONSTANTS.postOrderChangeQuantity
      .replace("{userId}", data.username)
    return this.apiService.post(endpoint, payload).pipe(map(({ body }: any) => body));
  }


  postOrderChangeQuantityAddLine(data: any, payload: any = {}) {
    const endpoint = API_CONSTANTS.postOrderChangeQuantityAddLine
      .replace("{userId}", data.username)
      .replace("{orderNumber}", data.orderNumber)
      .replace("{entryNumber}", data.entryNumber)
      .replace("{cancellationCode}", data.cancellationCode)
    return this.apiService.post(endpoint, payload).pipe(map(({ body }: any) => body));
  }

  getMinMaxValidation(data: any) {
    const endpoint = API_CONSTANTS.minMaxValidation
      .replace("{userId}", data.username)
      .replace("{SkuId}", data.SkuId)
      .replace("{numberOfRolls}", data.numberOfRolls)
      .replace("{targetLength}", data.targetLength)
    return this.apiService.post(endpoint, null).pipe(map(({ body }: any) => body));
  }

  postOrderCancelSolution(data: any, payload: any) {
    const endpoint = API_CONSTANTS.postOrderCancelSolution
      .replace("{userId}", data.username);
    return this.apiService.post(endpoint, payload).pipe(map(({ body }: any) => body));
  }

  getExcessQuantityLimit(data: any, payload: any) {
    const endpoint = API_CONSTANTS.excessQuantity
      .replace("{userId}", data.username);
    return this.apiService.post(endpoint, payload).pipe(map(({ body }: any) => body));
  }

  getEmailList(data:any){
    const endpoint = API_CONSTANTS.emailList
      .replace("{userId}", data.username)
  return this.apiService.get(endpoint).pipe(map(({ body }) => body));

  }

  populateEmailsForAutoComplete(data: any) {
    const endpoint = API_CONSTANTS.populateEmailsForAutoComplete
      .replace("{userId}", data.username)
      .replace("{customerQueries}", data.customerQueries);
    return this.apiService.get(endpoint).pipe(map(({ body }) => body));
  }
  // crest based code

  getMiniCartData(data: any = {}) {
    const url = API_CONSTANTS.miniCart
      .replace("{uid}", data?.uid)
      .replace("{customerNumber}", data?.customerNumber);
    return this.apiService.get(url).pipe(
      tap(({ body }) => {
        this.storageService.setItem("miniCartCount", body);
      }),
      map(({ body }) => body)
    );
  }

  addToCartCrest(data: any = {}, payload: any = {}) {
    const endpoint = API_CONSTANTS.addToCartCrest
    .replace("{userId}", data.userId)
    .replace("{cartId}", data.cartId);
    return this.apiService.post(endpoint, {
      ...payload,
      orderPlacedSite: "builder"
    }).pipe(map(({ body }: any) => body));
  }
  
  getProductPriceDetails(data: any = {}) {
    const endpoint = API_CONSTANTS.getProductPriceDetails
    .replace("{productCode}", data.productCode);
    return this.apiService.get(endpoint).pipe(map(({ body }: any) => body));
  }

  getProductDetails(data: any = {}) {
    const endpoint = API_CONSTANTS.productDetails
    .replace("{productCode}", data.productCode);
    return this.apiService.get(endpoint).pipe(map(({ body }: any) => body));
  }

  checkAvailabilityForProduct(data: any = {}, payload: any) {
    let endpoint = API_CONSTANTS.checkAvailability
    .replace("{userId}", data.userId);
    return this.apiService.post(endpoint, payload).pipe(map(({ body }: any) => body))
  }

  getProductMedias(code: any) {
    let url = API_CONSTANTS.productMedias.replace("{productCode}", code);
    return this.apiService.get(url);
  }
  

  getMinMaxRollLength(data: any = {}) {
    const endpoint = API_CONSTANTS.getMinMaxRollLength
      .replace("{standardRollLength}", data.standardRollLength)
      .replace("{productCode}", data.productCode)
      .replace("{shipTo}", data.shipTo)
      .replace("{soldTo}", data.soldTo)
      .replace("{uom}", data.uom);
    return this.apiService.get(endpoint).pipe(map(({ body }: any) => body));
  }

  addItemToPostOrder(data: any = {}, payload: any = {}) {
    const endpoint = API_CONSTANTS.addLineOrAccessories.replace("{userId}", data.userId)
    return this.apiService.post(endpoint, payload).pipe(map(({ body }: any) => body));
  }

  editPostOrderModications(data: any,customerId:any): Observable<any> {
    const url = API_CONSTANTS.postOrderUpdatePO.replace("{userId}",customerId);
    return this.apiService.post(url, data);
  }

  getCancelList(data: any) {
    let url = API_CONSTANTS.CancelReason.replace("{userId}",data.userId);
    url = url.replace("{type}", data.type);
    return this.apiService.get(url);
  }

  getShippingOptions(userId: any, productCode: any, isSample: any, ShipTo: any, soldTo: any) {
    const url = API_CONSTANTS.getShippingOptions
      .replace("{userId}", userId)
      .replace("{isSample}", isSample)
      .replace("{productCode}", productCode)
      .replace("{shipTo}", ShipTo)
      .replace("{soldTo}", soldTo);
    return this.apiService.get(url).pipe(map(({ body }) => body));
  }

  editPostOrderModicationNew(payload: any,userId:any): Observable<any> {
    const url = API_CONSTANTS.postOrderModificationNew.replace("{userId}",userId);
    return this.apiService.post(url, payload);
  }

  removeSelectedItemFromCart(cartId: any, entryNumber: any, userId: any): Observable<any> {
    const url = API_CONSTANTS.deleteLine.replace(
      "{userId}/carts/{cartId}/entries/{entryNumber}",
      `${userId}/carts/${cartId}/entries/${entryNumber}`
    );
    return this.apiService.post(url, {});
  }

  proceedToCheckoutOrderReview(data: any, payload: any) {
    const endpoint = API_CONSTANTS.orderReview
      .replace("{userId}", data.username)
      .replace("{cartId}", data.cartId);

      // Restructure cart repsone
    return this.apiService.post(endpoint, payload).pipe(map(({ body }: any) => {
      const entries = (body?.camsCartEntries || []).map((item: any) => {
        return (item.cartEntries || []).map((entry: any) => {
          const { cartEntries, ...camsDetails } = item || {};
          return {
            ...(entry || {}),
            __camsdetails: camsDetails,

          }
        });
      });
      body.entries = entries.flat();
      return body;
    }));


    // return this.apiService.post(endpoint, payload).pipe(map(({ body }: any) => body));
  }

  validateShippingOptions1(data: any = {}) {
    const endpoint = API_CONSTANTS.validateShippingOptionsV1
      .replace("{userId}", data.username)
      .replace("{incoLocation}", data.incoLocation)
      .replace("{productCat}", data.productCat)
      .replace("{shipVia}", data.shipVia);
    return this.apiService.get(endpoint).pipe(map(({ body }) => body));
  }

  getUOMDetails(data: any) {
    const endpoint = API_CONSTANTS.UOMDetails.replace("{productId}", data?.productId);
    return this.apiService.get(endpoint).pipe(map(({ body }) => body));
  }

  validateShippingOptions(payload: any) {
    let url = API_CONSTANTS.validateShippingOptions
      .replace("{incoTerm}", payload.wareHouse)
      .replace("{productCategory}", payload.erpProductCategory)
      .replace("{shipVia}", payload.shipVia);
    url = url.replace("{userId}", payload.userId);
    return this.apiService.get(url).pipe(map(({ body }: any) => body));
  }

  validateShipVia(data: any) {
    const endpoint = API_CONSTANTS.validateShipVia
      .replace("{userId}", data?.username)
      .replace("{shippingMethod}", data?.shippingMethod)
      .replace("{shipVia}", data?.shipVia)
    return this.apiService.get(endpoint).pipe(map(({ body }) => body));
  }

  getProductVariantMatrix(data: any = {}) {
    const endpoint = API_CONSTANTS.productVariantMatrix
      .replace("{productId}", data.productId)
      .replace("{fields}", data.fields);
    return this.apiService.get(endpoint).pipe(map(({ body }) => body));
  }

  removeATPCartEntry(data: any = {}, payload: any = {}) {
    const endpoint = API_CONSTANTS.removeATPCartEntry
    .replace("{userId}", data.userId);
    return this.apiService.delete(endpoint, { body: payload}).pipe(map(({ body }: any) => body));
    // return this.apiService.delete(endpoint,{body: payload});
  }

}